import { render, staticRenderFns } from "./marked.vue?vue&type=template&id=242e3c82&"
import script from "./marked.vue?vue&type=script&lang=js&"
export * from "./marked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports